import { css } from "styled-components"

export const boxShadow = css`0px 18px 36px rgba(0, 0, 0, 0.04),
        0px 8px 16px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.02),
        0px 2px 4px rgba(0, 0, 0, 0.02), 0px 0.5px 1px rgba(0, 0, 0, 0.011)`
